"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IWhitelist__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "paymaster",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address[]",
                name: "accounts",
                type: "address[]",
            },
        ],
        name: "AddedBatchToWhitelist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "paymaster",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "AddedToWhitelist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "paymaster",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address[]",
                name: "accounts",
                type: "address[]",
            },
        ],
        name: "RemovedBatchFromWhitelist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "paymaster",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "RemovedFromWhitelist",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_accounts",
                type: "address[]",
            },
        ],
        name: "addBatchToWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "addToWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sponsor",
                type: "address",
            },
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "check",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_accounts",
                type: "address[]",
            },
        ],
        name: "removeBatchFromWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "removeFromWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IWhitelist__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IWhitelist__factory = IWhitelist__factory;
IWhitelist__factory.abi = _abi;
